<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/setup/zone-setup/ic" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("setup.label.ViewIcZone") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteUserDataPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("setup.label.IncomingTrunkid") }}</b>
                </td>
                <td>{{ icZone.incomingTrunkId }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.OutcomingTrunkid") }}</b>
                </td>
                <td>{{ icZone.outgoingTrunkId }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.ImpactCategory") }}</b>
                </td>
                <td>{{ icZone.impactCategory }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Rank") }}</b>
                </td>
                <td>{{ icZone.rank }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      :title="$t('setup.label.IcZone')"
      @deletePressed="deleteUserData()"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      icZone: {},
      deleteUserDataPopup: false,
    };
  },

  computed: {
    ...mapState({
      numberZoneId: (state) => state.zoneSetup.numberZoneId,
    }),
  },
  methods: {
    async dataByIdIcZone() {
      try {
        await this.$store.dispatch("zoneSetup/fetchIcZoneDataAction", this.id);
        this.icZone = this.numberZoneId;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    editData(id) {
      this.$router.push({ name: "Edit IC Zone", params: { id: id } });
    },
  },
  filters: {},
  created() {
    this.id = this.$route.params.id;
    this.dataByIdIcZone();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
